var map = {
	"./Avatar-Default-AHTS.svg": 972,
	"./Avatar-Default-CREWBOAT.svg": 9306,
	"./Avatar-Default-ETV.svg": 8066,
	"./Avatar-Default-FSIV.svg": 555,
	"./Avatar-Default-IRM.svg": 2757,
	"./Avatar-Default-Installation.svg": 9112,
	"./Avatar-Default-MPSV.svg": 6985,
	"./Avatar-Default-Mooring-Buoy.svg": 6948,
	"./Avatar-Default-NoVessel.svg": 5225,
	"./Avatar-Default-PSV.svg": 6058,
	"./Avatar-Default-Port.svg": 5055,
	"./Avatar-Default-Rig.svg": 4025,
	"./Avatar-Default-SSRV.svg": 976,
	"./Avatar-Default-TANKER.svg": 9683,
	"./Avatar-Default-TUG.svg": 286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8773;